import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailTellentLogoComponent } from '../../components/email-tellent-logo/email-tellent-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { TellentProductsFooterComponent } from '../../components/tellent-products-footer/tellent-products-footer.component';
import { EmailMailgunIfDirective } from '../../directives/email-mailgun-if.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  styleUrls: ['../../global-styles.less', './tellent-email-confirmation.component.less'],
  templateUrl: './tellent-email-confirmation.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailTellentLogoComponent,
    TellentProductsFooterComponent,
    EmailMailgunIfDirective,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class TellentEmailConfirmationTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<TellentEmailConfirmationTemplateData>;
}

export type TellentEmailConfirmationTemplateData = {
  header: string;
  subheader_html: string;
  body_html: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
  primary_cta?: {
    href: string;
    label: string;
  };
};

export const TellentEmailConfirmationTemplateMocks: TellentEmailConfirmationTemplateData[] = [
  {
    header: 'Confirm your email',
    subheader_html: `Hi %{user_name}! 👋 We see that you’ve recently signed up for Tellent, but never confirmed your email. We get it - we’re all busy. You can do it now!`,
    body_html: 'Confirm your email and enjoy managing with Tellent.',
    footer: {
      text: 'Need help?',
      href: 'https://auth.tellent.com/?intercom_open=true',
      label: 'Contact us',
      target: '_blank',
    },
    primary_cta: {
      href: 'https://tellent.com',
      label: 'Confirm email',
    },
  },
];
